module.exports = __webpack_public_path__ + "banquet/components/images/chevron_white.2103ce567d924627315c14411a871bb8.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/chevron_white.svg
// module id = 1705
// module chunks = 1